import React, { useState } from "react";
import DoctorChip from "./DoctorChip";
import "./MassWeightModal.css";

const MassWeightModal = ({ doctors, onClose, onSave }) => {
  const [selectedDoctors, setSelectedDoctors] = useState([]);
  const [weight, setWeight] = useState(1.0);
  const [error, setError] = useState("");

  const handleSave = async () => {
    // Validate weight
    if (weight < 0 || weight > 1) {
      setError("Weight must be between 0 and 1");
      return;
    }

    // Validate doctor selection
    if (selectedDoctors.length === 0) {
      setError("Please select at least one doctor");
      return;
    }

    setError(""); // Clear any existing error
    await onSave(selectedDoctors, weight);
    onClose();
  };

  const handleWeightChange = (e) => {
    const value = parseFloat(e.target.value);
    setWeight(value);
    // Clear error if input becomes valid
    if (value >= 0 && value <= 1) {
      setError("");
    }
  };

  const handleDoctorClick = (doctorId) => {
    setSelectedDoctors((prev) => {
      if (prev.includes(doctorId)) {
        return prev.filter((id) => id !== doctorId);
      } else {
        return [...prev, doctorId];
      }
    });
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Set Scheduling Weight</h2>
        <div className="weight-input-section">
          <label>Weight:</label>
          <input
            type="number"
            step="0.1"
            min="0"
            max="1"
            value={weight}
            onChange={handleWeightChange}
          />
        </div>

        {error && <div className="error-message">{error}</div>}

        <div className="doctor-selection-section">
          <label>Select Doctors:</label>
          <div className="doctor-selection-grid">
            {doctors.map((doctor) => (
              <DoctorChip
                key={doctor.staffId}
                doctor={doctor}
                selectable
                selected={selectedDoctors.includes(doctor.staffId)}
                onClick={() => handleDoctorClick(doctor.staffId)}
              />
            ))}
          </div>
        </div>

        <div className="modal-actions">
          <button className="primary-button" onClick={handleSave}>
            Save
          </button>
          <button className="secondary-button" onClick={onClose}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default MassWeightModal;
